import React, {Component} from 'react';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";
import InputMask from 'react-input-mask';

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import ToggleInput from "../../../../components/ToggleInput/toggleInput";
import translator from "../../../../utils/translations";
import {ajaxHandler} from "../../../../utils/errors";

export default class ProviderForm extends Component {

    constructor(props) {
        super(props);

        let activeState = {
            id: null,
            business_name: '',
            cuit: '',
            email: '',
            can_create_cif_trips: null
        };

        if (this.props.item) {
            let provider = this.props.item;
            activeState = {
                id: provider.id,
                business_name: provider.business_name,
                cuit: provider.cuit,
                email: provider.email,
                can_create_cif_trips: provider.can_create_cif_trips
            };
        }

        this.state = {
            ...activeState,
            ajaxInProgress: false
        };
    }

    _handleInput = (prop, value) => {

        if(prop === 'cuit'){
            value = value.replace(/-/g, '');
        }

        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['ajaxInProgress', 'id'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});

        if(this.state.id){
            const UPDATE_PROVIDER = `${urls.API_ROOT}/api/v1/provider/id/${this.state.id}/`;
            axios.put(`${UPDATE_PROVIDER}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }else{
            const NEW_PROVIDER = `${urls.API_ROOT}/api/v1/provider/`;
            axios.post(`${NEW_PROVIDER}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Proveedor ${this.state.id ? 'actualizado' : 'creado'}`,
            html: 'La información ingresada ha sigo guardada correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la información del proveedor',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {
        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{this.state.id ? 'Edición de Proveedor' : 'Alta Proveedor'}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.business_name} type={"text"}
                               onChange={(ev) => this._handleInput('business_name', ev.target.value)}
                        />
                        <label className="active">Razón Social</label>
                    </div>
                    <div className={"col s12 input-field"}>
                        <InputMask placeholder={"Ingrese un valor"} value={this.state.cuit}
                               mask={'99-99999999-9'}
                               onChange={(ev) => this._handleInput('cuit', ev.target.value)}
                        />
                        <label className="active">CUIT</label>
                    </div>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.email} type={"email"}
                               onChange={(ev) => this._handleInput('email', ev.target.value)}
                        />
                        <label className="active">Correo electrónico</label>
                        <ToggleInput
                            selected={this.state.can_create_cif_trips}
                            name={'¿Puede crear viajes CIF?'}  stateVar={'can_create_cif_trips'}
                            toggleAction={this._handleToggle}
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Guardar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ProviderForm.js